<template>
<label for='file-loader'
       class='fw-file-loader__wrapper'
       :class='`fw-file-loader__wrapper--${type}`'
       @drop.prevent='addFile'
       @dragover.prevent>
    <div class='fw-file-loader__text'>
        <FwIcon
            class='h-mb-25'
            icon='upload'
            size='38'
            color='#BEC7D4'>
        </FwIcon>

        <div v-if='file'
             class='h-mb-15 h-flex-center'>
            <div>
                {{ file.name }} ({{ file.size | kb }} kb)
            </div>
            <FwIcon
                class='h-ml-10 h-mt-2 h-pointer'
                icon='delete'
                size='32'
                color='#BEC7D4'
                @click.native='removeFile(file)'>
            </FwIcon>
        </div>

        <div>
            <b>
                {{ dragText }}
            </b> {{ dragAsideText }}
        </div>
    </div>

    <input id='file-loader'
           class='h-hidden-force'
           type='file'
           accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
           @change='addFile'>

    <FwButton
        v-if='uploadDisabled'
        class='h-mt-15'
        :inversed='true'
        color='primary'
        @click.stop='handleUpload'>
        Upload
    </FwButton>
</label>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import FwButton from '../FwButton.vue';

const AVAILABLE_TYPES: Array<string> = ['base'];

Vue.filter('kb', (value: number) => {
    return Math.floor(value / 1024);
});

@Component({
    components: {
        FwButton,
    },
})
export default class FwFileLoader extends Vue {
    @Prop({ type: String, default: 'base', validator: (type: string) => AVAILABLE_TYPES.includes(type) }) readonly type!: string;
    @Prop({ type: String, required: true }) readonly dragText!: string;
    @Prop({ type: String, required: true }) readonly dragAsideText!: string;

    file: File | null = null;
    availableExtensions: Array<string> = ['csv', 'xls', 'xlsx'];

    get uploadDisabled() {
        return Boolean(this.file);
    }

    addFile(event: any) {
        let file;
        if (event.target.files && event.target.files.length) {
            // eslint-disable-next-line prefer-destructuring
            file = event.target.files[0];
        } else if (event.dataTransfer ** event.dataTransfer.length) {
            // eslint-disable-next-line prefer-destructuring
            file = event.dataTransfer.files[0];
        }
        if (!file) return;
        const fileName: string = file.name;
        const fileNameSplit: Array<string> = fileName.split('.');
        const extensions: string = fileNameSplit[fileNameSplit.length - 1].toLowerCase();
        if (this.availableExtensions.includes(extensions)) {
            this.file = file;
        } else {
            this.$emit('error');
        }
    }
    removeFile() {
        this.file = null;
    }

    @Emit('upload')
    handleUpload(file: File) {
        return file;
    }
}
</script>

<style lang='sass'>
.fw-file-loader
    cursor: pointer
    &__wrapper
        &--base
            width: 600px
            height: 320px
            display: flex
            align-items: center
            justify-content: center
            background-color: #fff
            border-radius: 20px
            border: 2px dashed $alt-blue
            flex-direction: column

            @include media('<=phone')
                width: 100%
                height: auto
                padding: 40px 0

        .fw-file-loader__text
            font-size: 16px
            line-height: 22px
            color: $alt-blue
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            max-width: 400px
            padding: 0 10px

            @include media('<=phone')
                width: 100%
                padding: 0 15px
                text-align: center
</style>
